import { PropsWithChildren } from "react";
import Card from "./Card";

export default function SettingsSectionLayout({
  title,
  children,
}: PropsWithChildren<{
  title: string;
}>) {
  return (
    <Card header={<div className="text-lg font-bold">{title}</div>}>
      <div className="flex flex-col gap-10 items-start">{children}</div>
    </Card>
  );
}
